import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import UserMenu from './userMenu';
import * as Actions from 'actions';
import * as Permissions from 'permissions';

import {Modal} from 'react-bootstrap';

import {ClientFormNew, HeaderSearchBar} from '../';
import Notifications from './notifications';
import Notification from './notification';
import { UserHeaderNotifications } from 'components';

class HeaderMenu extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			add_client_open: false,
			connection_warning_open: false,
			closing_connection_warning: false
		}
		this.handleCloseModal = this.handleCloseModal.bind(this);
		this.handleShowAddClient = this.handleShowAddClient.bind(this);
		this.handleClickTasksSidebarToggle = this.handleClickTasksSidebarToggle.bind(this);

		this.connection_warning_timer = null;
		this.closing_connection_warning_animation_timer = null;
	}

	handleCloseModal() {
		this.props.stopCreatingClient()
	}
	handleShowAddClient() {
		this.setState({add_client_open : false});
		this.props.startCreatingClient();
	}
	componentDidMount() {
		// I know.. it's a hack, but the onClick handler ws giving me a weird error, and we launch in 2 days
		let _self = this;
		$('.toggle-sidebar-left').on('click', _self, () => {
			if(_self.props.ui.show_sidebar_container) {
				_self.props.toggleShowSidebarContainer(false);
			}
			else {
				_self.props.toggleShowSidebarContainer(true);
			}
		})
	}
	componentWillUpdate(next_props) {
		if(this.props.socket.connected && !next_props.socket.connected) {
			this.setState({ connection_warning_open: true });
			this.closing_connection_warning_animation_timer = setTimeout(() => {
				this.setState({ closing_connection_warning: true });
				this.closing_connection_warning = setTimeout(() => {
					this.setState({ closing_connection_warning: false, connection_warning_open: false });
				}, 3000);
			}, 4000);
		}
		else if(!this.props.socket.connected && next_props.socket.connected) {
			clearTimeout(this.connection_warning_timer);
			clearTimeout(this.closing_connection_warning_animation_timer);
			this.setState({ connection_warning_open: false, closing_connection_warning: false });
		}
	}
	handleClickTasksSidebarToggle() {
		this.props.toggleShowTasksSidebar();
	}

	render() {
		const {socket} = this.props;
		const _self = this;

		return (
			<div className='header-container'>
				<Modal
					bsSize='large'
					className='edit-client-model'
					show={_self.props.show_create_client}
					onHide={_self.handleCloseModal}
					aria-labelledby='contained-modal-title-lg'
					>
	        <ClientFormNew
	        	title='Create New Client'
	        	client={{}}
	        	onCancel={_self.handleCloseModal}
	        />
	      </Modal>
				<header className='header'>
					<div className='logo-container'>
						<a href='/' className='logo'>
							<img
								src={(this.props.user.logo || {}).url || 'assets/images/ic_launcher.png'}
								height={this.props.user.logo? 35 : 40}
								alt='Hailtrace Admin' />
						</a>
						<div className='header-right-buttons'>
							<div
	              className='sidebar-right-toggle tasks-sidebar-toggle-button'
	              data-open='sidebar-right'
	              onClick={this.handleClickTasksSidebarToggle}
	              >
	              <i className='fa fa-thumb-tack tasks-sidebar-toggle' />
	            </div>
							<div
								className="visible-xs toggle-sidebar-left"
								data-toggle-class="sidebar-left-opened"
								data-target="html"
								data-fire-event="sidebar-left-opened"
								>
								<i className="fa fa-bars" aria-label="Toggle sidebar"></i>
							</div>
						</div>
					</div>
					<div className='hidden-xs header-right'>
            {this.props.hasPermission(Permissions.VIEW_CLIENTS) ? <div className='hidden-sm search nav-form'>
              <HeaderSearchBar />
            </div> : ''}
            <span className='separator'></span>

						<Notifications>
							<UserHeaderNotifications />
              { this.props.hasPermission(Permissions.VIEW_CLIENTS) ?
                <Notification title={'Search Clients'} iconClass='fa fa-search' className={'hidden-sm hidden-md hidden-lg hidden-xl'} status='default'>
                  <HeaderSearchBar />
                </Notification>
              : ''}
							{this.props.hasPermission(Permissions.CREATE_CLIENTS) ?
                <Notification title={'Create'} iconClass='fa fa-user-plus' open={this.state.add_client_open} customButtonClass={'add-client-button'}>
  								<span onClick={this.handleShowAddClient} style={{cursor: 'pointer'}} className={`text-success`}><i className='fa fa-user-plus'></i> Add Client</span>
  							</Notification>
              : ''}
							<Notification title='Help Center' iconClass='fa fa-life-ring' status='info'>
								<p className='text-dark text-center'>or</p><p className='text-dark'>
									<a href='http://help.hailtrace.com' target='_blank' className='btn btn-primary' style={{ display:'inline' }}>Help Center</a>
								</p>
							</Notification>
							<Notification
								title={'Connection Status'}
								iconClass='fa fa-globe'
								status={socket.connected ? 'success' : 'danger'}
								open={this.state.connection_warning_open}
								closing={this.state.closing_connection_warning}
								>
								<span className={`text-${socket.connected ? 'success' : 'danger'}`}>
									<i className='fa fa-globe' /> {socket.connected?  'Connected' : 'Disconnected (Try Refreshing)'}
								</span>
								<hr />
								<p className='mt-sm mb-sm'><a className='btn btn-block btn-default mb-sm' href='http://status.hailtrace.com' target='_blank'>
									<i className='fa fa-server' /> Check Server Status.
								</a></p>
							</Notification>
						</Notifications>
						<span className='separator'></span>
						<UserMenu />
					</div>
				</header>
			</div>
		)
	}
}

let mapStateToProps = ({users, ui, socket, fields}) => ({user : users.user, ui, socket, fields})

export default connect(mapStateToProps, Actions)(HeaderMenu)



// WEBPACK FOOTER //
// ./src/browser/components/header/headerMenu.js